import { render, staticRenderFns } from "./CertificateLinkCompanyDialog.vue?vue&type=template&id=728c2f82&scoped=true&"
import script from "./CertificateLinkCompanyDialog.vue?vue&type=script&lang=js&"
export * from "./CertificateLinkCompanyDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728c2f82",
  null
  
)

export default component.exports